import { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import Layout from "@/components/layout/Layout";
import DirectoryHero from "@/components/mall/map/DirectoryHero";
import SoloHome from "@/components/mall/solo/SoloHome";
import { DirectoryBillboards, MenuTiles } from "@/components/directory/DirectoryBlocks";
import { useMall } from "@/context/MallContext";

/**
 * The directory and nothing more: the list of shops, the map, the platform's billboards and the
 * six menu doors. Color starts when you click a shop.
 */
export default function Home() {
    const { leave, solo, soloByHost, site, exitSolo } = useMall();
    const isDirectory = useLocation().pathname === "/directory";

    useEffect(() => { leave(); }, [leave]);
    useEffect(() => { if (isDirectory && solo && !soloByHost) exitSolo(); }, [isDirectory, solo, soloByHost, exitSolo]);

    if (site?.standalone && isDirectory && soloByHost) return <Navigate to="/" replace />;
    if (solo && !isDirectory) return <SoloHome />;

    return (
        <Layout>
            <DirectoryHero />
            <DirectoryBillboards />
            <MenuTiles />
        </Layout>
    );
}
